import React from "react";
import PodiumHourlyFlowChart from "./PodiumHourlyFlowChart";
import "./PodiumSnapshots.css";

function groupSnapshotsByLocation(podiumSnapshots) {
    const grouped = new Map();

    podiumSnapshots.forEach((item) => {
        const locationName = item?.locationName || "Location";
        if (!grouped.has(locationName)) grouped.set(locationName, []);
        grouped.get(locationName).push(item);
    });

    return Array.from(grouped.entries()).map(([locationName, items]) => ({ locationName, items }));
}

const PodiumSnapshots = ({ loading, error, podiumSnapshots, accessibleLocations, selectedLocationId, selectedDate, dateFilter, userTimeZone }) => (
    <div className="dashboard-snapshot-box">
        {loading && <div>Loading...</div>}
        {error && <div className="dashboard-error">{error}</div>}
        {podiumSnapshots.length > 0 && (
            <div>
                <div className="dashboard-snapshot-title">
                    {selectedLocationId === "all" ? "All Accessible Locations" : accessibleLocations.find((l) => l.id === selectedLocationId)?.name} Overview ({dateFilter?.label || selectedDate || "Today"})
                </div>
                {selectedLocationId === "all" ? (
                    <div className="dashboard-location-groups">
                        {groupSnapshotsByLocation(podiumSnapshots).map(({ locationName, items }) => (
                            <div
                                key={locationName}
                                className="dashboard-location-group">
                                <div className="dashboard-location-group-title">{locationName}</div>
                                <div className="dashboard-podium-pie-row dashboard-podium-pie-row-grouped">
                                    {items.map(({ podium, snapshot }) => {
                                        const resolvedPodiumId = Number(snapshot?.podiumId || podium.id);
                                        const activeCount = Number(snapshot?.activeOnDate || snapshot?.currentlyInPossession || 0);
                                        const capacity = snapshot?.parkingCapacity == null ? null : Number(snapshot.parkingCapacity);
                                        const isCapacityValid = Number.isFinite(capacity) && capacity > 0;
                                        const utilizationPct = isCapacityValid ? Math.min(999, Math.round((activeCount / capacity) * 100)) : null;
                                        return (
                                            <div
                                                className="dashboard-podium-pie-container"
                                                key={podium.id}>
                                                <div className="dashboard-podium-title">{podium.name}</div>
                                                <div className="dashboard-pie-total">Currently Parked: {activeCount}</div>
                                                <div className="dashboard-podium-fullness">{isCapacityValid ? `Capacity: ${activeCount}/${capacity} (${utilizationPct}% full)` : "Capacity: Not set"}</div>
                                                <PodiumHourlyFlowChart
                                                    podiumId={resolvedPodiumId}
                                                    dateFilter={dateFilter}
                                                    userTimeZone={userTimeZone}
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="dashboard-podium-pie-row">
                        {podiumSnapshots.map(({ podium, snapshot }) => {
                            const resolvedPodiumId = Number(snapshot?.podiumId || podium.id);
                            const activeCount = Number(snapshot?.activeOnDate || snapshot?.currentlyInPossession || 0);
                            const capacity = snapshot?.parkingCapacity == null ? null : Number(snapshot.parkingCapacity);
                            const isCapacityValid = Number.isFinite(capacity) && capacity > 0;
                            const utilizationPct = isCapacityValid ? Math.min(999, Math.round((activeCount / capacity) * 100)) : null;
                            return (
                                <div
                                    className="dashboard-podium-pie-container"
                                    key={podium.id}>
                                    <div className="dashboard-podium-title">{podium.name}</div>
                                    <div className="dashboard-pie-total">Currently Parked: {activeCount}</div>
                                    <div className="dashboard-podium-fullness">{isCapacityValid ? `Capacity: ${activeCount}/${capacity} (${utilizationPct}% full)` : "Capacity: Not set"}</div>
                                    <PodiumHourlyFlowChart
                                        podiumId={resolvedPodiumId}
                                        dateFilter={dateFilter}
                                        userTimeZone={userTimeZone}
                                    />
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        )}
    </div>
);

export default PodiumSnapshots;
